import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=1f1dc0ca&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.vue?vue&type=style&index=0&id=1f1dc0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1dc0ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/home/runner/work/marketing/marketing/components/Video.vue').default})
